import { LinearGradient } from 'expo-linear-gradient'
import { useRouter } from 'expo-router'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { ScrollView, View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { Spacer } from '@/src/elements/spacer/Spacer'
import { Typography } from '@/src/elements/text/Typography'
import { GTM } from '@/src/general/utils/gtm'
import { EVENTS } from '@/src/general/utils/gtm/constants'
import { useTranslate } from '@/src/lang/useTranslate'

import { useUpdateXMRPMCTAHistory } from '../../services/useXMRPMRedirect'

import MaryAndRoses from '@/img/rosario/mary-and-roses.svg'

const ctaUrls = {
  fr: 'https://app.adjust.com/1einihhx?campaign=so_5mrpm-o_lp_ope_5mrpm-d_2026_05_07&adgroup=users_hozana_fr&creative=cta_post_reward&redirect=https%3A%2F%2Frosario.app%2F5mrpm%2F?utm_source=1einihhx%26utm_campaign=so_5mrpm-o_lp_ope_5mrpm-d_2026_05_07%26utm_medium=users_hozana_fr%26utm_term=cta_post_reward',
  en: 'https://app.adjust.com/1einihhx?campaign=so_5mrpm-o_lp_ope_5mrpm-d_2026_05_08&adgroup=users_hozana_en&creative=cta_post_reward&redirect=https%3A%2F%2Frosario.app%2F5mrpm%2Fen%2F?utm_source=1einihhx%26utm_campaign=so_5mrpm-o_lp_ope_5mrpm-d_2026_05_08%26utm_medium=users_hozana_en%26utm_term=cta_post_reward',
  es: 'https://app.adjust.com/1einihhx?campaign=so_5mrpm-o_lp_ope_5mrpm-d_2026_05_09&adgroup=users_hozana_es&creative=cta_post_reward&redirect=https%3A%2F%2Frosario.app%2F5mrpm%2Fes%2F?utm_source=1einihhx%26utm_campaign=so_5mrpm-o_lp_ope_5mrpm-d_2026_05_09%26utm_medium=users_hozana_es%26utm_term=cta_post_reward',
  pt: 'https://app.adjust.com/1einihhx?campaign=so_5mrpm-o_lp_ope_5mrpm-d_2026_05_10&adgroup=users_hozana_pt&creative=cta_post_reward&redirect=https%3A%2F%2Frosario.app%2F5mrpm%2Fpt%2F?utm_source=1einihhx%26utm_campaign=so_5mrpm-o_lp_ope_5mrpm-d_2026_05_10%26utm_medium=users_hozana_pt%26utm_term=cta_post_reward',
  it: 'https://rosario.app/it',
  pl: 'https://rosario.app/pl',
}

type TXMRPMScreenProps = {
  redirect: string
}

export const XMRPMScreen = ({ redirect }: TXMRPMScreenProps) => {
  const { t } = useTranslate()
  const router = useRouter()
  const { locale } = useIntl()

  useUpdateXMRPMCTAHistory()

  useEffect(() => GTM.sendEvent(EVENTS.XMRPM_CTA_DISPLAYED), [])

  const handleParticipateCta = () => {
    GTM.sendEvent(EVENTS.XMRPM_CTA_CLICKED)
    router.navigate(ctaUrls[locale])
  }

  const handleNotNow = () => {
    GTM.sendEvent(EVENTS.XMRPM_CTA_DISMISSED)
    router.navigate(redirect)
  }

  return (
    <ScrollView className="w-full min-h-screen">
      <LinearGradient
        colors={['#FECC74', '#FFF6E5']}
        style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}
      />
      <View className="w-full items-center h-[584px]">
        <MaryAndRoses />
      </View>
      <View className="p-4 pb-6 gap-2.5 items-center bg-[#FFF6E5E6] md:bg-transparent rounded-t-2xl -mt-28 md:mt-0 max-w-80 md:max-w-none mx-auto">
        <Typography bold center size="3xl" className="text-[#E84F02]">
          {t('rosario.xmrpms.title')}
        </Typography>
        <Typography center>{t('rosario.xmrpms.description')}</Typography>
        <Typography center>{t('rosario.xmrpms.objective')}</Typography>
        <Spacer y={2} />
        <Button colors="primary" variant="solid" onPress={handleParticipateCta}>
          {t('rosario.xmrpms.cta')}
        </Button>
        <Button colors="primary" variant="light" onPress={handleNotNow}>
          {t('words.not-now')}
        </Button>
      </View>
    </ScrollView>
  )
}
